import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { GameFont } from "../../../common/GameFont";
import { PiggyMultiplier } from "../../../common/components/PiggyMultiplier";

export class BuildingPiggyMultiplier extends Container {
    private readonly roundedRectangle: Sprite;
    private readonly multiplierIcon: PiggyMultiplier;
    private readonly multiplierText: Text;

    public constructor(commonResources: CommonResourcesPackage, multiplierValue?: string) {
        super();
        this.roundedRectangle = new Sprite(commonResources.assets_common_ui_rounded_rectangle_png);
        this.multiplierIcon = new PiggyMultiplier(commonResources);
        this.multiplierIcon.scale.set(0.7);
        this.multiplierIcon.position.set(3, 3);
        this.multiplierText = new Text(`${multiplierValue ?? '0%'}`, new MultiplierTextStyle());
        this.multiplierText.position.set(multiplierValue?.length > 4 ? 66 : 70, 17);

        this.addChild(
            this.roundedRectangle,
            this.multiplierIcon,
            this.multiplierText
        );
    }
}

class MultiplierTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 32,
            fill: 'FFFFFF'
        });
    }
}
